import { render, staticRenderFns } from "./GenericHistogramCompareChart.vue?vue&type=template&id=f493e958"
import script from "./GenericHistogramCompareChart.vue?vue&type=script&lang=js"
export * from "./GenericHistogramCompareChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports